import { memo, useCallback, useMemo } from 'react';
import { ReactSVG } from 'react-svg';
import { getMinioUrl } from '../../utils/urlUtils';
import { Jersey } from '../../@types';

type JerseyDisplayProps = Pick<Jersey, 'patternId' | 'firstColor' | 'secondColor' | 'thirdColor'> & {
  width?: number | string;
  height?: number | string;
};

const formatColor = (color: string) => `#${color}`;

const JerseyDisplay = ({
  patternId,
  firstColor,
  secondColor,
  thirdColor,
  width = 40,
  height = 40,
}: JerseyDisplayProps) => {
  const minioBaseUrl = getMinioUrl();

  const colorMap = useMemo(
    () => ({
      '.cls-1': formatColor(firstColor),
      '.cls-2': formatColor(secondColor),
      '.cls-3': formatColor(thirdColor),
    }),
    [firstColor, secondColor, thirdColor]
  );

  const handleColorInjection = useCallback(
    (svg: SVGSVGElement) => {
      Object.entries(colorMap).forEach(([selector, color]) => {
        const element = svg.querySelector(selector);
        if (element instanceof SVGElement) {
          element.style.setProperty('fill', color);
        }
      });
    },
    [colorMap]
  );

  if (!minioBaseUrl) {
    return null;
  }

  const jerseyUrl = `${minioBaseUrl}/resources/jerseys/shirt_${patternId}.svg`;

  return (
    <ReactSVG
      src={jerseyUrl}
      style={{ width, height, flexShrink: 0, margin: 0 }}
      beforeInjection={handleColorInjection}
    />
  );
};

export default memo(JerseyDisplay);
